import fleet from "../assests/images/fleet.png";
import weather from "../assests/images/weather.png";
import laundry from "../assests/images/laundry.png";
import travel from "../assests/images/travel.png";
import cadet from "../assests/images/cadet.png";
import hospital from "../assests/images/hospital.png";
export const Bio = {
  name: "Rahul Lohar",
  roles: [
    "Frontend Developer",
    "UI/UX Designer",
    "Programmer",
    "Software Developer",
  ],
  description:
    "Motivated and creative, I turn challenges into purposeful solutions.Always evolving — crafting clean, user-focused web experiences.",
  github: "https://github.com/RAHULLOHAR7",
  resume:
    "https://drive.google.com/file/d/1aZeqgSaP_bVsrctXwmvq-Iqa1PsZSmYO/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/rahul-l-2a3a71161",
  twitter: "https://x.com/RahulLo45110711",
  insta:
    "https://www.instagram.com/rahul_lohar.07/profilecard/?igsh=aG8zZzRvZXlpOHIw",
  // facebook: "https://www.facebook.com/prasad-aswar/",
  // Youtube: "https://www.youtube.com/channel/UC2va0f_ebk-ebvOBbz7M3-w",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://img.icons8.com/?size=100&id=21278&format=png&color=000000",
      },
      {
        name: "JavaScript",
        image:
          "https://img.icons8.com/?size=100&id=108784&format=png&color=000000",
      },
      {
        name: "React JS",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      // {
      //   name: "Redux",
      //   image:
      //     "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      // },
      {
        name: "Next JS",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "React Native ",
        image:
          "https://img.icons8.com/?size=100&id=25Sjy8fKExYA&format=png&color=000000",
      },
      // {
      //   name: "Angular Js",
      //   image:
      //     "https://camo.githubusercontent.com/8886130b3d8aba95dbdd7c4f9a41029606424cc06d1873c1ced87dd55a222fef/68747470733a2f2f616e67756c61722e696f2f6173736574732f696d616765732f6c6f676f732f616e67756c61722f616e67756c61722e737667",
      // },

      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node JS",
        image: "https://nodejs.org/static/images/logo.svg",
      },

      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },

      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "PHP",
        image: "https://www.php.net/images/logos/new-php-logo.png",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://img.icons8.com/?size=100&id=p2VooZ9Gcgxm&format=png&color=000000",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "WebFlow",
        image: "https://dhygzobemt712.cloudfront.net/Mark/Mark_Logo_White.png",
      },
      {
        name: "WordPress",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/09/Wordpress-Logo.svg",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
    role: "Software Engineer - Web developer",
    company: "Accenture (Payroll: Expedite Software)",
    date: "Nov 2025 - Present",
    desc: "Developed and maintained responsive, pixel-perfect email templates and reusable fragments using HTML5 & CSS3 for Astellas (Japan region), worked on Veeva CRM to upload and deploy campaign assets, ensured cross-client compatibility across Outlook, Gmail, and mobile devices using email-safe practices, implemented table-based layouts with inline CSS for consistent rendering, and performed QA testing, debugging, and optimization for high-quality delivery.",
    skills: ["HTML", "CSS", "CMS"],
    // doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
  },
  {
    id: 1,
    // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
    role: "React Developer",
    company: "Native Consultancy",
    date: "Jan 2024 - Nov 2025",
    desc: "Developed and maintained scalable single-page applications (SPAs) using React.js, ensuring responsive design andcross-browser compatibility.Built reusable functional components with React Hooks (useState, useEffect, useContext, etc.) and custom hooksfor clean, modular code.Implemented state management using Redux Toolkit and Context API to manage complex application data. Integrated RESTful APIs using Axios and Fetch API, handling asynchronous data and error management. Utilized React Router for client-side routing and navigation between views with protected routes and conditional rendering.",
    skills: ["ReactJS", "NodeJs", "HTML", "CSS", "JavaScript"],
    // doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
  },
  {
    id: 2,
    // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
    role: "Frontend Developer Intern",
    company: "AK INFOSOL PVT. LTD",
    date: "Sept 2022 - Feb 2023",
    desc: " During my internship at A.K, I played a pivotal role in developing and enhancing frontend components for web applications, leveraging my expertise in HTML, CSS, JavaScript, SQL, and PHP. Demonstrated adaptability and problem-solving skills in addressing technical challenges and meeting project deadlines effectively.",
    skills: ["JavaScript", "HTML", "CSS", "Php", "MySQL"],
    // doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
  },
  {
    id: 3,
    // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
    role: "Software developer Intern",
    company: "A3 PIXELS Pvt.Ltd",
    date: "March 2021 - Aug 2021",
    desc: "Done some projects for clients based on Ecommerce through Html,CSS,JS and learned some video editing and transcript editing as well as Photoshop Work on website named Cosmos where all this editing skills where used",
    skills: ["HTML", "CSS", "Php", "Figma", "MySQL"],
    // doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  },
];

export const education = [
  {
    id: 0,
    // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Kiit.jpeg?alt=media&token=3839d520-c59d-4341-ad8f-0980c98de4dd",
    school: "Alard Institute Of Management Sciences, Pune",
    date: "Aug 2021 - Oct 2023",
    grade: "8.21 CGPA",
    desc: "Completed my Post Graduation in MCA from SPPU",
    degree: "MCA(Master of Computer Applications)",
  },
  {
    id: 1,
    // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
    school: "Sahyog College Of Management Studies",
    date: "Aug 2018 - Apr 2021",
    grade: "82%",
    desc: "Completed my Graduation in BCA",
    degree: "BCA(Bachelor of Computer Applications)",
  },
  {
    id: 2,
    // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
    school: "St. Lawrence College Of Science - Commerce",
    date: "2018",
    grade: "62%",
    degree: "HSC",
  },
  {
    id: 3,
    // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
    school: "Sankalp English School",
    date: "2016",
    grade: "62%",
    degree: "SSC",
  },
];

export const projects = [
  {
    id: 11,
    title: "Dynamic Weather Application",
    // date: "Jan 2024 - Dec 2023",
    description:
      "Developed an application to display real-time weather information for specific locations.Utilised React to showcase current time and date dynamically. Leveraged Real-Time API’s to ensure up-to-date weather data.",
    image: weather,
    tags: ["React Js"],
    category: "All",
    github: "https://github.com/RAHULLOHAR7/Weather-Application",
    webapp: "https://rahullohar-weather-app.netlify.app/",
  },
  {
    id: 1,
    title: "The Laundry Concierge",
    // date: "Feb 2024",
    description:
      "A modern fabric-care service offering laundry, dry cleaning, and ironing with convenient doorstep pickup and delivery.",
    image: laundry,
    tags: ["HTML", "CSS", "JavaScript", "React", "API integration"],
    category: "web app",
    // github: "https://github.com/Prasadasw/digital-marketing-.git",
    webapp: "https://thelaundryconcierge.com/",
  },
  {
    id: 5,
    title: "Cadet Management",
    // date: "Jun 2023",
    description:
      "Developed a role-based Cadet Management System web app for managing cadet life-cycle activities including battalion performance, hostel management, outpass handling, staff tracking, and parental interactions. Focused on delivering an optimized, secure and scalable front-end solution with modern React practices and integrations.",
    image: cadet,
    tags: ["React.js", "React Hook Form", "Axios", "Context API"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Todo-Web-App",
    webapp: "https://ddabattalion.com/admin/auth",
  },
  {
    id: 7,
    title: "Fleet Management Software",
    // date: "Present",
    description:
      "A smart fleet management platform designed to optimize logistics operations through real-time GPS tracking, route planning, fuel monitoring, and automated maintenance alerts. I contributed to the frontend development, focusing on building responsive dashboards, integrating APIs for live tracking, and enhancing user experience across key modules.",
    tags: ["Java", "React Native"],
    image: fleet,
    category: "web app",
    // github: "https://github.com/rishavchanda/Quiz-Earn",
    webapp: "https://fleetspeed.io/",
  },
  {
    id: 9,
    title: "Hospital Management System(Collage Based Project)",
    // date: "Feb 2024",
    description:
      "Hospital Management System In PHP is web based application. The project Hospital Management system includes registration of patients, storing their details into the system. The software has the facility to give a unique id for every patient and stores the details of every patient.",
    image: hospital,
    tags: ["HTML", "CSS", "JavaScript", "PHP"],
    category: "android app",
    // github: "https://github.com/Prasadasw/digital-marketing-.git",
    // webapp: "https://thelaundryconcierge.com/",
  },

  {
    id: 8,
    title: "Tours and Travels Website(Collage Based Project)",
    // date: "Jan 2021",
    description:
      "Online Tours & Travels management system: This is an online project developed using PHP and MySQL. The purpose of this project is to provide the complete information about the vehicles available for a tour",
    image: travel,
    tags: ["PHP", "MYSQL"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    // webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  },
];

// export const TimeLineData = [
//   { year: 2017, text: "Started my journey" },
//   { year: 2018, text: "Worked as a freelance developer" },
//   { year: 2019, text: "Founded JavaScript Mastery" },
//   { year: 2020, text: "Shared my projects with the world" },
//   { year: 2021, text: "Started my own platform" },
// ];
